module.exports = {
      id: "strategy-usage",
      viewBox: "0 0 13.247 22.012",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#strategy",
      toString: function () {
        return this.url;
      }
    }